module.exports = __webpack_public_path__ + "img/pinkLily.381c1b8e.jpg";